import type { UserInfo } from "@/core/user/userEntity";
import { GLOBAL_CONFIG } from "@/global-config";
import DashboardLayout from "@/layouts/dashboard";
import LoginAuthGuard from "@/routes/components/login-auth-guard";
import {
	concatParentPath,
	removeAllButtonChild,
	removeEmptyNode,
	sortTreeByOrder,
	transformMenu2Routes,
} from "@/utils/menu";
import { pipe } from "ramda";
import { Suspense, lazy } from "react";
import { Navigate } from "react-router";
import { authRoutes } from "./auth";
import { mainRoutes } from "./main";
import { Component } from "./dashboard/utils";

// bujuan CLI 一键授权页:需登录、不进菜单、全屏无侧边栏(未登录时页面自己存回跳地址再去 /login)
const CliAuthPage = lazy(() => import("@/pages/cli-auth"));

const buildDynamicRoutes = (user?: UserInfo) => {
	// 根据后端返回的 menus 构建动态路由，用 ramda 纯函数拼接
	const dynamicRoutes = pipe(
		sortTreeByOrder,
		removeEmptyNode,
		concatParentPath(""),
		removeAllButtonChild,
		transformMenu2Routes,
	)(user?.menus || []);
	console.log("dynamicRoutes", dynamicRoutes);
	return [
		// Auth
		...authRoutes,
		// bujuan CLI 一键授权(全屏,不套 DashboardLayout)
		{
			path: "cli-auth",
			element: (
				<Suspense fallback={<div>Loading...</div>}>
					<CliAuthPage />
				</Suspense>
			),
		},
		// Dashboard
		{
			element: (
				<LoginAuthGuard>
					<DashboardLayout />
				</LoginAuthGuard>
			),
			children: [
				{
					index: true,
					element: <Navigate to={GLOBAL_CONFIG.defaultRoute} replace />,
				},
				{
					path: GLOBAL_CONFIG.defaultRoute,
					element: Component("/pages/home"),
				},
				...dynamicRoutes,
			],
		},
		// Main
		...mainRoutes,
		// No Match
		{
			path: "*",
			element: (
				<LoginAuthGuard>
					<Navigate to="/404" replace />
				</LoginAuthGuard>
			),
		},
	];
};

export default buildDynamicRoutes;
